import type React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styles from "./index.module.scss";

interface TabItem {
  label: string;
  content: React.ReactNode;
}

interface CommonTabsProps {
  tabs: TabItem[];
  selectedIndex?: number;
  onSelect?: (index: number) => void;
  className?: string;
  disabled?: boolean;
}

const CommonTabs: React.FC<CommonTabsProps> = ({
  tabs,
  selectedIndex = 0,
  onSelect,
  className,
  disabled = false,
}) => {
  const handleSelect = (index: number) => {
    if (!disabled && onSelect) {
      onSelect(index);
    }
  };

  return (
    <Tabs
      className={`${styles["tabs"]} ${className || ""} ${disabled ? styles["disabled"] : ""}`}
      selectedIndex={selectedIndex}
      onSelect={handleSelect}
    >
      <TabList className={styles["tabList"]}>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            className={`${styles["tab"]} ${disabled ? styles["tabDisabled"] : ""}`}
            selectedClassName={styles["tabSelected"]}
            disabled={disabled}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      {tabs.map((tab, index) => (
        <TabPanel key={index} className={styles["tabPanel"]}>
          {tab.content}
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default CommonTabs;
